import config from 'devextreme/core/config';

type DevExtremeLicenseFile = {
  licenseKey?: string;
};

function validateDevExtremeLicense() {
  let licenseKey: string;

  if (import.meta.env.PROD) {
    licenseKey = import.meta.env.REACT_APP_DX_LK ?? '';
  } else {
    const mods = import.meta.glob('/src/devextreme-license.ts', { eager: true });
    const mod = mods['/src/devextreme-license.ts'] as DevExtremeLicenseFile | undefined;
    licenseKey = mod?.licenseKey ?? '';
  }

  config({ licenseKey });
}

export default validateDevExtremeLicense;
